export default class Link {
    constructor(text, href, active = false) {
        this.text = text;
        this.href = href;
        this.active = active;
    }
}
